import { useCallback, useState, useEffect } from 'react';
import { Suggestions } from '../types';

const useSelectSuggestion = ({
    suggestions,
}: {
    suggestions: Suggestions[];
}) => {
    const [selectedSuggestionIndex, setSelectedSuggestionIndex] = useState(-1);

    // reset selection
    useEffect(() => {
        setSelectedSuggestionIndex(-1);
    }, [suggestions]);

    const resetSelectedSuggestion = useCallback(() => {
        setSelectedSuggestionIndex(-1);
    }, [setSelectedSuggestionIndex]);

    const selectPreviousSuggestion = useCallback(() => {
        const isFirstSuggestion = selectedSuggestionIndex === -1;
        const newIndex = isFirstSuggestion
            ? suggestions.length - 1
            : selectedSuggestionIndex - 1;

        setSelectedSuggestionIndex(newIndex);
    }, [selectedSuggestionIndex, suggestions]);

    const selectNextSuggestion = useCallback(() => {
        const isLastSuggestion =
            selectedSuggestionIndex === suggestions.length - 1;
        const newIndex = isLastSuggestion ? -1 : selectedSuggestionIndex + 1;

        setSelectedSuggestionIndex(newIndex);
    }, [selectedSuggestionIndex, suggestions]);

    return {
        selectPreviousSuggestion,
        selectNextSuggestion,
        resetSelectedSuggestion,
        selectedSuggestionIndex,
    };
};

export default useSelectSuggestion;
